<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle1"><a id="page_xx"></a><a id="page_xxi"></a>The Clandestine History<br/>of the<br/>Kovno Jewish Ghetto Police</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?38649123